import { __generator } from "tslib";
import { call } from 'redux-saga/effects';
import { request } from '../../xhr';
import { getBackgrounds } from './_fixtures';
export function doFetchBackgrounds(offset, limit) {
    var params, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: '/deviation/backgrounds',
                        params: params,
                    }, function () {
                        return { results: getBackgrounds(), hasMore: false };
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doSetBackground(deviationid, backgroundid) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    deviationid: deviationid,
                    backgroundid: backgroundid,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/deviation/set_background',
                        data: data,
                    }, function () {
                        return { success: true };
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
//# sourceMappingURL=xhr.js.map